import { useQuery } from '@tanstack/react-query';
import {
  COMPANY_PROFILE_DEFAULTS, COMPANY_PROFILE_FIELDS, LEGAL_PAGE_DEFAULTS,
  type CompanyProfile,
  type LegalPageSlug, type PublicCompanyProfileResponse, type PublicLegalPageResponse,
} from '@mbbe/types';
import { apiFetch } from '../lib/apiClient';

export function useCompanyProfile() {
  const { data, isPending } = useQuery({
    queryKey: ['site', 'profile'],
    queryFn: ({ signal }) => apiFetch<PublicCompanyProfileResponse>('/site/profile', { signal }),
    staleTime: 0,
    retry: false,
  });
  const profile = data?.profile ? Object.fromEntries(COMPANY_PROFILE_FIELDS.map(field => [field, data.profile[field] ?? ''])) as unknown as CompanyProfile : COMPANY_PROFILE_DEFAULTS;
  return { ...profile, isPending, legalTitles: data?.legalTitles };
}

export function useLegalPage(slug: LegalPageSlug) {
  const { data, isPending } = useQuery({
    queryKey: ['site', 'legal-page', slug],
    queryFn: ({ signal }) => apiFetch<PublicLegalPageResponse>(`/site/legal-pages/${slug}`, { signal }),
    staleTime: 0,
    retry: false,
  });
  const defaults = LEGAL_PAGE_DEFAULTS[slug];
  const tr = data?.tr?.markdown.trim() ? data.tr : defaults.tr;
  // An empty English translation falls back as a whole, including its title.
  const en = data ? (data.en?.markdown.trim() ? data.en : tr) :
    (defaults.en.markdown.trim() ? defaults.en : tr);
  return { tr, en, isPending, updatedAt: data?.updatedAt ?? null };
}
